import { useEffect, useMemo } from 'react';
import { Box, Typography } from "@mui/material";
import BotMessageSettings from "./BotMessageSettings";
import QuickResponseSettings from "./QuickResponseSettings";
import AutomationsSetting from "./AutomationsSetting";
import PermissionSetting from "./PermissionSetting";
import AppearanceSetting from "./AppearanceSetting";
import { useConciergeStore } from '../../../store/conciergeStore';

export default function SettingsPage({ active }) {
  const user = useMemo(() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
  }, []);
  const propertyId = user?.property?._id || user?.properties?.[0]?.propertyId?._id;

  const {
    quickResponses,
    quickResponsesLoading,
    fetchQuickResponses,
    saveQuickResponses,
    automations,
    automationsLoading,
    fetchAutomations,
    saveAutomations
  } = useConciergeStore();

  // Fetch automations when entering the Automations tab
  useEffect(() => {
    if (active === 'auto' && propertyId) {
      fetchAutomations(propertyId);
    }
  }, [active, propertyId, fetchAutomations]);

  useEffect(() => {
    if (active === 'fast' && propertyId) {
      fetchQuickResponses(propertyId);
    }
  }, [active, propertyId, fetchQuickResponses]);

  let content;

  switch (active) {
    case "bot":
      content = (
        <BotMessageSettings
          onSave={(payload) => {
            // TODO: integrate with your API/store
            console.debug("[BotMessageSettings] save", payload);
          }}
          onCancel={() => {
            console.debug("[BotMessageSettings] cancel");
          }}
        />
      );
      break;
    case "fast":
      content = (
        <QuickResponseSettings
          initial={quickResponses}
          loading={quickResponsesLoading}
          onSave={(list) => saveQuickResponses(propertyId, list)}
          onRefresh={() => fetchQuickResponses(propertyId)}
        />
      );
      break;
    case "auto":
      content = (
        <AutomationsSetting
          initial={automations}
          onSave={(rules) => saveAutomations(propertyId, rules)}
        />
      );
      break;
    case "roles":
      content = (
        <PermissionSetting
          onSave={(roles) => {
            // TODO: integrate with your API/store
            console.debug("[PermissionSetting] save", roles);
          }}
        />
      );
      break;
    case "appearance":
      content = (
        <AppearanceSetting
          onSave={(payload) => {
            // TODO: integrate with your API/store
            console.debug("[AppearanceSetting] save", payload);
          }}
          onCancel={() => {
            console.debug("[AppearanceSetting] cancel");
          }}
        />
      );
      break;
    default:
      content = (
        <Box>
          <Typography variant="body1">Select a setting from the left list.</Typography>
        </Box>
      );
  }

  return (
    <Box sx={{ p: 3, flexGrow: 1, overflow: "auto" }}>
      {content}
    </Box>
  );
}
